import { createSliceWithThunks } from '../helpers';
import reducers from './reducers';
import selectors from './selectors';
import { storeName } from './consts';
import { ProductsStoreStateInitial } from './types';

const initialState: ProductsStoreStateInitial = {
  loading: 'idle',
  error: null,
  ids: [],
  entities: {}
};

export const productsSlice = createSliceWithThunks({
  name: storeName,
  initialState,
  selectors,
  reducers
});

export const {
  updateProducts,
  increaseQuantity,
  decreaseQuantity,
  setQuantity,
  deleteProducts,
  deleteAllProducts,
  markForDeletion,
  markAsDeleted,
  cancelDeletion
} = productsSlice.actions;

export const {
  selectLoading,
  selectProducts,
  selectProductsIds,
  selectHasProducts
} = productsSlice.selectors;

export default productsSlice.reducer;
